import { PuzzleInfoResponse } from 'client/player/js/actions/gameInfoActions'
import { type FinishPuzzleReturnDto } from 'client/types/FinishedPuzzle'
import { ApiResult, klubbleAPI } from './common'
/*
 * gameEvents.ts defines endpoints for sending game status events
 * to the backend like:
 * 'puzzle started', 'timer resumed', 'puzzle solved'
 *
 * */

export const startPuzzle = async (klubblePuzzleId: number, isOpenForGameRoom = false): Promise<PuzzleInfoResponse> => {
  const res = await klubbleAPI.post<PuzzleInfoResponse>('/Puzzle/startPuzzle', {
    klubblePuzzleId,
    isOpenForGameRoom,
  })

  if (!res.data.success) {
    throw new Error(res.data.message)
  }

  return res.data
}

export const finishPuzzle = async (klubblePuzzleId: number, totaltime: number): Promise<FinishPuzzleReturnDto> => {
  const { data: response } = await klubbleAPI.post<ApiResult<FinishPuzzleReturnDto>>('/Puzzle/finishpuzzle', { klubblePuzzleId, totaltime })

  if (!response.success) {
    throw new Error(response.message)
  }

  return response.data
}
